import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import AchievementWidgetFooterSkeleton from './AchievementWidgetFooterSkeleton'

const AchievementWidgetFooterPlaceholder = () => (
  <AchievementWidgetFooterSkeleton
    header={
      <LoadingBox width={400} height={30} maxWidth="100%" mb="1x">
        &nbsp;
      </LoadingBox>
    }
  />
)

export default AchievementWidgetFooterPlaceholder
